import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";

import {api,API_UR} from '../../actions/_request';

import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import FAprint from 'react-icons/lib/fa/print';

export default class EntragasDiarias extends React.Component{
	constructor(props){
		super(props);
		this.state={
			data : [],
			fetch : false,
		}
	}

	componentDidMount(){
		let self = this;
	

		api().get(this.props.datos)
        .then(function(response)
        {
            self.setState({
                data : response.data,
                fetch : true
            });  
		});
	}

	render(){
		let {data}= this.state;
		console.log(data)
		return(
			<Card>
			<CardTitle>
			
				
            
            </CardTitle>
			<CardBlock>
				
	            {

				fetch &&
				<ReactTable
					data= {this.state.data}
		            className = "-striped -highlight"
		            columns   = {[ 
			            {Header: 'Clave', accessor: 'clave'},
			            {Header: 'Cliente', accessor: 'tecnico'},
			            {Header: 'Cobro', accessor: 'cobro'},
			            {Header: 'Tipo Pago', accessor: 'tipo_pago'},
			            {Header: 'total', accessor: 'total'},
		            ]}
		            filterable 
		            defaultPageSize={10} 

				/>
			}
			</CardBlock>
			</Card>
			)
	}
}


// WEBPACK FOOTER //
// ./src/views/reportes/reportessinpv.js